import { Api } from '@shared/api';

export class AnalyticsApi extends Api {
  public async trackBid({
    sessionId,
    clientId,
    auctionId,
    transactionHash,
  }: {
    sessionId: string;
    clientId: string;
    auctionId: string;
    transactionHash: string;
  }): Promise<void> {
    const response = await this.fetch(`${this.baseUrl}/analytics/track-bid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId,
        clientId,
        auctionId,
        transactionHash,
      }),
    });

    return response.json();
  }
}
